/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var esUtils = require('ES/utils/esUtils');
var FormMixin = require('ES/widgets/forms/FormMixin');
var HorizontalFields = require('ES/widgets/HorizontalFields');
let FormUtils = require('../../../../../../utils/FormUtils');

module.exports = dd.createClass({
	getInitialState: function(){
		return {show_form: false};
	},
	__toggleForm: esUtils.wrapPreventDefault(function(){
		this.setState({show_form: !this.state.show_form});
	}),
	__onSubmit: function(data){
		var event = _.cloneDeep(this.props.event);
		event.sids = [_.parseInt(data.sid)];
		radio('save_Event').broadcast(event);
		this.setState({show_form: false});
	},
	render: function(){
		var event = this.props.event;
		var Displaylists = this.props.Displaylists;

		var my_speakers = FormUtils.getSpeakerNamesBySid(Displaylists, false);
		if(_.size(my_speakers) <= 1){
			return dd.div();
		}
		if(!this.state.show_form){

			return (event.is_mp_event) ? dd.div(null) : dd.p(null,
				dd.button({className: 'btn btn-default', onClick: this.__toggleForm}, 'Change Speaker')
			);

		}
		return dd.div({className: 'panel panel-default'},
			dd.div({className: 'panel-body'},
				dd.h4({className: 'section-head', style: {marginTop: 0}}, 'Change Speaker'),
				DaForm({event: event, my_speakers: my_speakers, onSubmit: this.__onSubmit, onCancel: this.__toggleForm})
			)
		);
	}
});

var DaForm = dd.createClass({
	mixins: [FormMixin],
	getInitialValuesSourceVersion: function(props){
		return esUtils.getEventVersionIdentifier(props.event);
	},
	getInitialValues: function(props){
		return {
			sid: _.first(props.event.sids)
		};
	},
	buildFields: function(){
		var my_speakers = this.props.my_speakers;
		return {
			sid: {
				label: 'Speaker',
				type: 'select',
				options: my_speakers
			}
		};
	},
	render: function(){
		var fields = this.buildFields();
		var errors = this.state.errors || {};
		var onCancel = this.props.onCancel;

		return dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
			HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput
			}),
			HorizontalFields.FormButtons({
				onCancel: onCancel
			})
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/event_actions/ChangeSpeaker.js